module.exports = __webpack_public_path__ + "static/media/greenCircledCheckmark.924cce45.svg";